var _defs, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#005EB8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70,7l54,31.5v63.1l-54,31.5-54-31.5V38.45L70,7M70,0,10,35v70l60,35,60-35V35L70,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.36,81.49h9.4V62.29h-9.4ZM70.1,58.68a5.62,5.62,0,1,0-5.62-5.62A5.62,5.62,0,0,0,70.1,58.68ZM40,33v70h60V33ZM70,99.23a3.75,3.75,0,1,1,3.75-3.75A3.74,3.74,0,0,1,70,99.23ZM90,88H50V43H90Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBold);
export default __webpack_public_path__ + "static/media/info-bold.4ca12f28e67a49fbf5f1830a3afe7d9f.svg";
export { ForwardRef as ReactComponent };